// extracted by mini-css-extract-plugin
export var legendIndicator = "_bd-1";
export var legendRight = "_bd-0";